import { render, staticRenderFns } from "./welcomeSpeech.vue?vue&type=template&id=ec5ae494&scoped=true"
import script from "./welcomeSpeech.vue?vue&type=script&lang=js"
export * from "./welcomeSpeech.vue?vue&type=script&lang=js"
import style0 from "./welcomeSpeech.vue?vue&type=style&index=0&id=ec5ae494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ae494",
  null
  
)

export default component.exports